var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonGallery.jinja');
require('./CommonGallery.less');

var objectFitImages = require('object-fit-images');
require('assets/owl.carousel.min.css');
require('assets/owl.theme.default.min.css');
require('owl.carousel.min-2.2.1.js');

module.exports = Base.extend({

    template: template,

    events: {
        'click .CommonGallery-galleryItem': 'onGalleryItemClick'
    },

    CAPTION_FADE_DURATION: 250,


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'loadNextAfterThat');

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

        this.initGallery();
    },


    destroy: function () {
        this.destroyed = true;

        return Base.prototype.destroy.call(this);
    },


    initGallery: function () {
        var carouselSelector = '.CommonGallery-galleryCarousel';
        var itemsCount = this.$('.CommonGallery-galleryItem').length;

        this.$(carouselSelector).owlCarousel({
            items: 1,
            nav: itemsCount > 1,
            dots: itemsCount > 1,
            dotsEach: Math.ceil(itemsCount / 10), //no more than 10 dots
            loop: itemsCount > 1,
            mouseDrag: false,
            smartSpeed: 500
        });

        //lopp issues, first item is not 0
        var firstItem = this.$('.CommonGallery-galleryCarousel .owl-item.active').index();

        this.updateCaption(firstItem);

        this.$(carouselSelector).on('changed.owl.carousel', function (e) {
            this.updateCaption(e.item.index);
        }.bind(this));

        this.$(carouselSelector)
            .find('.owl-prev')
            .html(this.$('.CommonGallery-galleryPrev svg'));

        this.$(carouselSelector)
            .find('.owl-next')
            .html(this.$('.CommonGallery-galleryNext svg'));

        //sequentally load images one by one
        this.loadNextAfterThat(this.$('.CommonGallery-galleryItem').eq(0));
    },


    onGalleryItemClick: function (e) {
        var $item = $(e.currentTarget);

        //if any A inside - skip newxt image switch (this is member gallery case)
        if ($item.find('a').length) return;

        this.$('.CommonGallery-galleryCarousel').trigger('next.owl.carousel');
    },


    updateCaption: function (ind) {
        var $itemCaption = this.$('.CommonGallery-galleryItem .CommonGallery-galleryItemCaption').eq(ind);
        var $galleryCaption = this.$('.CommonGallery-caption').eq(0);
        var $clone = $galleryCaption.clone();

        $clone
            .appendTo($galleryCaption.parent())
            .css({
                'position': 'absolute',
                'left': 0,
                'top': 0
            });

        $clone.fadeOut(this.CAPTION_FADE_DURATION, function () {
            $clone.remove();
        }.bind(this));

        $galleryCaption
            .html($itemCaption.html())
            .fadeOut(0)
            .fadeIn(this.CAPTION_FADE_DURATION);


        // this.$('.CommonGallery-galleryCarousel')
        //     .find('.owl-dots')
        //     .css('margin-top', this.$('.CommonGallery-captionWrapper').outerHeight(true));
    },


    loadNextAfterThat: function ($item) {
        if (this.destroyed) return;

        var $image = $item.find('img');
        var image = $image[0];
        var self = this;
        var $next = $item.closest('.owl-item').next();
        var self = this;

        var loadFunction = function () {
            if (self.destroyed) return;

            image.onload = null;
            image.onerror = null;

            objectFitImages(image);

            if ($next.length) {
                self.loadNextAfterThat($next);
            }
        };

        //start load
        $image
            .attr('sizes',  $image.attr('data-sizes'))
            .attr('srcset',  $image.attr('data-srcset'))
            .attr('src',  $image.attr('data-src'));

        if (image.complete || image.complete == undefined) {
            loadFunction();
        } else {
            image.onload = loadFunction;
            image.onerror = loadFunction;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonGallery/CommonGallery.js
// module id = 25
// module chunks = 0